<template lang="html">
  <div id="vergelijk">

    <div class="banner">
      <div class="top-header" style="height:125px;background:#f0f8ff;background:#2ecc7114 !important;">
        <i class="mdi mdi-car-hatchback driving-car" ></i>
        <i class="mdi mdi-tree front-tree"></i>
        <i class="mdi mdi-tree back-tree"></i>

        <Shape class="position-absolute shape bottom-1"/>
      </div>
    </div>


    <!-- INTRO -->
    <div class="features pb-30 mb-5 p-5">
      <div class="container">
        <div class="row">
          <div class="col-md-5 intro">
            <h4 v-scroll-to="'#whatthelike'" class="mouseover">Autokosten</h4>
            <h1 itemprop="name">TCO Vergelijker</h1>

            <div class="row">
              <div class="col-md-12">
                <p>
                  WhatTheRange rekent graag de autokosten voor je uit. Selecteer een elektrische auto en  maak en eigen keuze op basis van <b>looptijd</b> en <b>kilometrage</b> wat voor jou van toepassing is om een volledig overzicht van alle vaste en variabele <b>kosten per maand</b> te bekijken.
                </p>
              </div>

            </div>
          </div>
          <div class="col-md-7 justify-content-center d-flex text-center">
            <div class="row col-md-6 d-flex card__border align-items-center">
              <h4 class=" ml-2">Selecteer een auto</h4>
              <div class="col-12 p-1 d-flex flex-column align-items-center">
                <label for=""><b>Merk</b> </label>
                <v-select
                  class="style-chooser mt-2 w-100"
                  v-model="selectedMerk"
                  placeholder="Kies een merk"
                  :options="merken"
                />
              </div>
              <div class="col-12 p-1 d-flex flex-column align-items-center">
                <label for=""><b>Model</b></label>
                <v-select
                  class="style-chooser mt-2 w-100"
                  v-model="selectedModel"
                  placeholder="Kies een model"
                  :options="modellen"
                />
              </div>
              <div class="col-12 p-1 d-flex flex-column align-items-center" v-if="((selectedMerk !== undefined) && (selectedModel !== undefined) && modellen.length > 0 && uitvoeringen.length > 0)">
                <label for=""><b>Uitvoering</b></label>
                <v-select
                  class="style-chooser mt-2 w-100"
                  v-model="selectedUitvoering"
                  placeholder="Kies een uitvoering"
                  @input="openTCO()"
                  :options="uitvoeringen"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import Banner from '@/components/Banner'
    import Shape          from '@/components/design/shape'
    import vSelect from 'vue-select';

export default {
    components:{
        Banner,
        Shape,
        vSelect
    },
    async asyncData({app, store, params}) {
      await store.dispatch('getModels')
    },
    methods : {
        openTCO(){
            let uitvoeringType = this.selectedUitvoering.split(' (')[0];
            let type = this.uitvoeringMotoren.find((uitvoering) => {
                return uitvoering.cTypenaam_1 === uitvoeringType;
            })
            let typeinformation = type.typeinformation[0];
            let title = `${typeinformation.cMerknaam} ${typeinformation.cModelnaam} ${typeinformation.cTypenaam_1} ${typeinformation.cTypenaam_2}`;
            this.$router.push({  name: 'vergelijk-autokosten-carid-cars', params: { carid: typeinformation.nTypeIDHist, cars: title.replace(/\s/g , "-") }});
        }
    },
    computed: {
        getModels () {
            return this.$store.getters.getModels
        }
    },
    data(){
        return  {
            selectedMerk: undefined,
            selectedModel: undefined,
            selectedUitvoering: undefined,
            merken: [],
            modellen: [],
            uitvoeringen: [],
            uitvoeringMotoren: [],
        }
    },
    watch: {
      selectedMerk: function(newVal){
          this.selectedModel = undefined;
          this.selectedUitvoering = undefined;
          let modellen = this.getModels.map((modellen) => {
              if(modellen.cMerknaam === newVal){
                  return modellen.cModelnaam;
              }
          });
          this.modellen = modellen.filter(function (el) {
              return el != null;
          });
      },
      selectedModel: function(newVal){
          this.selectedUitvoering = undefined;
          let uitvoeringMotoren = this.getModels.map((modellen) => {
              if(modellen.cModelnaam === newVal){
                  return modellen.motor;
              }
          });

          this.uitvoeringMotoren = uitvoeringMotoren.filter(function (el) {
                  return el != null;
              }).flat();
          this.uitvoeringen = this.uitvoeringMotoren.map(motor=>{
              return `${motor.cTypenaam_1} (${Math.round(parseInt(motor.Vermogen_elektromotor_kW) * 1.36)}pk)`
          });
      }
    },
    mounted(){
        this.merken = this.getModels.map(item => item.cMerknaam)
            .filter((value, index, self) => self.indexOf(value) === index)
    },
}
</script>

<style lang="scss">

  @import "../../../node_modules/vue-select/src/scss/vue-select.scss";
  #navigation{
    position: fixed;
    background-color: #effbf4;
  }
  .card__border{
    background-color:#2ecc71;
    padding: 16px !important;
    border-radius: 8px;
    h4{
      color: #fff ;
    }
    label{
      b{
        color: #fff;
      }
    }
  }
  h5{
    color: #666 !important;
    font-weight: 600 !important;
    font-size: 16px !important;
    // height:90px;
    padding-top:5px;
    background: #fff;
  }
  .top-line{
    width: 200px;
    height: 75px;
    z-index: -1;
    background: transparent;
    border: none;
    border-top: dashed 3px #2ecc71;
    border-radius: 50%;
    position: absolute;
    top: -17px;
    right: -100px;
    // right: -66px;
    opacity: 0.5;
  }
  .top-line-double{
    width: 550px;
    height: 129px;
    z-index: -1;
    background: transparent;
    border: none;
    border-top: dashed 3px #2ecc71;
    border-radius: 50%;
    position: absolute;
    top: -45px;
    right: -455px;
    // left: 250px;
    opacity: 0.5;
  }

  .co2-tree{
    font-size: 35px;
    position: absolute;
    margin-top: -18px;
    opacity: 0.5;
    right:90px;
  }
  .alternative{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    overflow: hidden;
    background-color: #f0f8ff;
    color: #FFF;
    transition: all 500ms;
  }

  .fact{
    padding-top: 0;
    color: #b1b1b1 !important;
    line-height: 16px;
    margin-bottom: 1rem;
  }
  .alternative.active {
    top: 100%;
    height: 0;
  }

  .total-block{
    padding: 15px 30px;

    span{
      font-size: 18px;
    }
  }
  #vergelijk{
    ul{
      list-style-type: none;
      padding: 0;
      li{
        color:#232323 !important;
        font-family: 'Poppins', sans-serif;

        // font-weight: 600;
      }
      span{
        color: #666 !important;
        font-family: 'Poppins', sans-serif;

        // font-weight: 600;
      }
    }

    ul.tco-costs{
      li{
        text-align:left;
        padding: 10px 30px;
      }
    }

    .highlighted::after{
      content: 'Elektrisch';
      display: inline-block;
      position: absolute;
      right: -50px;
      top: 20px;
      background-color: #2ecc71;
      text-transform: uppercase;
      font-weight: 700;
      font-size: 12px;
      color: white;
      line-height: 40px;
      width: 200px;
      -webkit-transform: rotate(45deg);
      -moz-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      -o-transform: rotate(45deg);
      transform: rotate(45deg);
    }

    .vergelijk{
      background: #fff;
      border-radius: 8px;
      padding-bottom: 10px;
      margin-bottom: 0px;
      height:100%;
      .pattern{
        border-radius: 8px;
      }
      a{
        padding: 10px 20px;
        background: #2ecc71;
        margin-right: 10px;
        border-radius: 30px;
        color: #fff !important;
        text-decoration: none;
        font-weight: 600;
        font-family: 'Poppins', sans-serif;

        border: 2px solid #2ecc71;
      }
    }
    p.desc{
      font-family: 'Poppins', sans-serif;

      font-weight: 600;
      position: relative;
      z-index: 999;
      max-width: 850px;
      margin: 0 auto;
    }

    h3{
      font-size: 14px;
      padding-bottom: 20px;
      color:#666 !important;
      font-weight: 600;
    }

    a.secondary, p.secondary{
      background: #fff !important;
      color:#2ecc71 !important;
      border: 2px solid #2ecc71;
    }

    .paddle{
      padding: 10px 20px;
      background: #2ecc71;
      margin-right: 10px;
      border-radius: 30px;
      color: #fff !important;
      text-decoration: none;
      font-weight: 600;
      font-family: 'Poppins', sans-serif;

      border: 2px solid #2ecc71;
      background: #fff !important;
      color:#2ecc71 !important;
      border: 2px solid #2ecc71;
      outline: none !important;
    }

    /* The heart of the matter */
    /* The heart of the matter */
    .testimonial-group {
      overflow-x: auto !important;
      white-space: nowrap !important;
      // flex-wrap: nowrap;
    }
    .col-block{
      // display: inline-block;
      // float: none;
    }
    .swiper-pagination-bullet-active{
      background: #2ecc71;
    }


  }
  .vs__dropdown-toggle {
    border-radius: 30px;
  }
  .vs__dropdown-menu {
    border-bottom-left-radius: 30px;
    border-bottom-right-radius: 30px;
    /*border: 1px solid #f1f1f1;*/
    border: none;
    box-shadow: 0 0 0 1px transparent, 0 0 0 1px #f1f1f1 !important;
    border-top: 0;
    box-shadow: none;
  }
  .vs__dropdown-option--highlight{
    background-color: #2ecc71 !important;
  }
  .style-chooser {
    &.vs--open {
      border-bottom-right-radius: 0px !important;
      border-bottom-left-radius: 0px !important;
    }
    box-shadow: inherit;
    border: 1px solid #f1f1f1;
    -webkit-border-radius: 30px;
    -moz-border-radius: 30px;
    border-radius: 30px;
    max-width: 225px;
    .vs__open-indicator{
      display:none;
    }
    .vs__dropdown-toggle{
      border: 0;
      padding-left: 20px;
      width: 100%;
      min-height: 60px;
      color: #232323;
      outline: none;
      font-weight: 400;
      font-family: 'Open Sans', sans-serif;

      font-size: 14px;
      z-index: 99999;
      background:#fff;
    }
  }
  .vs__clear{
    display: none;
  }
</style>
